<ecp-hero title="Frame to Come" image="assets/images/headers/experts.jpg"> </ecp-hero>

<mat-card class="mat-card--widget frame-shipment-page">
  <mat-card-content>
    <div class="container">
      <div class="row mb-10">
        <div class="col s12 offset-m10">
          <button class="btn btn-primary" routerLink="/frame-to-come"> Create New</button>
        </div>
      </div>
      <div class="row">
        <div class="col s12 is-flex is-fullwidth track-shipment-page">
          <table
            mat-table
            #outerSort="matSort"
            [dataSource]="trackingData"
            multiTemplateDataRows
            class="mat-elevation-z8"
            matSort
          >
            <ng-container matColumnDef="dropshipName">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Laboratory</th>
              <td mat-cell *matCellDef="let element">{{ element?.dropshipName }}</td>
            </ng-container>
            <ng-container matColumnDef="trackingNumber">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Tracking Number</th>
              <td mat-cell *matCellDef="let element" class="text-center">
                <a [href]="element.trackingUrl" target="_blank"> {{ element.trackingNumber }}</a>
              </td>
            </ng-container>
            <ng-container matColumnDef="createdDate">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Shipping Cart Date</th>
              <td mat-cell *matCellDef="let element">{{ element.createdDate + 'Z' | date: 'short' }}</td>
            </ng-container>
            <ng-container matColumnDef="frameCount">
              <th mat-header-cell *matHeaderCellDef>Item Count</th>
              <td mat-cell *matCellDef="let element">{{ element.frameItems.length }}</td>
            </ng-container>
            <ng-container matColumnDef="expand">
              <th mat-header-cell *matHeaderCellDef aria-label="row actions">&nbsp;</th>
              <td mat-cell *matCellDef="let element" class="text-center">
                <button
                  class="btn btn-primary"
                  (click)="expandOrder = expandOrder === element ? null : element; $event.stopPropagation()"
                >
                  Details
                </button>
              </td>
            </ng-container>

            <ng-container matColumnDef="expandedDetail">
              <td
                mat-cell
                *matCellDef="let element; let i = dataIndex"
                [attr.colspan]="trackingColumnWithExpand.length"
              >
                <div class="example-element-detail" [@detailExpand]="element == expandOrder ? 'expanded' : 'collapsed'">
                  <ecp-frame-shipment-details
                    [framesInfo]="element"
                    [labLocations]="labLocation"
                    [framesIndex]="i"
                    style="width: 100%;"
                  ></ecp-frame-shipment-details>
                </div>
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="trackingColumnWithExpand"></tr>
            <tr
              mat-row
              *matRowDef="let element; columns: trackingColumnWithExpand"
              class="example-element-row"
              [class.example-expanded-row]="expandOrder === element"
            ></tr>
            <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="example-detail-row"></tr>
          </table>
          <ng-container *ngIf="trackingData.data.length == 0">
            <div class="row">
              <div class="col m8 s12 offset-m2 mt-10 mb-10">
                <h3 class="mt-10 mb-10">
                  Your Frame to Come Cart is currently empty. Please take a moment to search selection and add your
                  desired frames.
                </h3>
              </div>
            </div>
          </ng-container>
          <mat-paginator #outerPaginate="matPaginator" [pageSizeOptions]="[10, 20, 30]" showFirstLastButtons>
          </mat-paginator>
          <!-- End Container -->
        </div>
      </div>
    </div>
  </mat-card-content>
</mat-card>
